// Init Photoswipe.js
// es6
//
// uses:
// - https://github.com/dimsemenov/photoswipe
// - https://github.com/dimsemenov/photoswipe-dynamic-caption-plugin
// - https://photoswipe.com/getting-started/

const smallScreenPadding = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
};
const largeScreenPadding = {
  top: 30,
  bottom: 30,
  left: 0,
  right: 0,
};

const options = {
  gallery: 'body',
  children: '.photoswipe',
  paddingFn: (viewportSize) => {
    return viewportSize.x < 900 ? smallScreenPadding : largeScreenPadding;
  },
  pswpModule: () => import(window.APU.photoswipe.module),
};
let lightbox;
let caption;
let instance;

function getLightbox() {
  if (!lightbox) {
    lightbox = import(window.APU.photoswipe.lightbox).then(
      (module) => module.default,
    );
  }
  return lightbox;
}

function getDynamicCaption() {
  if (!caption) {
    caption = import(window.APU.photoswipe.caption).then(
      (module) => module.default,
    );
  }
  return caption;
}

function initPhotoswipe() {
  if (
    typeof window.APU === 'undefined' ||
    window.APU === null ||
    !window.APU.photoswipe
  ) {
    return;
  }

  if (
    window.APU.photoswipe.module &&
    window.APU.photoswipe.lightbox &&
    window.APU.photoswipe.caption &&
    document.querySelector(options.gallery)
  ) {
    getLightbox()
      .then((lightbox) => {
        if (instance) {
          instance.destroy();
        }
        instance = new lightbox(options);
        return instance;
      })
      .then(addCaptions)
      .then((instance) => {
        instance.init();
      });
  }
}

function addCaptions(lightbox) {
  return getDynamicCaption().then((dynamicCaption) => {
    new dynamicCaption(lightbox, {
      // Plugin options
      mobileLayoutBreakpoint: 900,
      type: 'auto',
      horizontalEdgeThreshold: 20,
      mobileCaptionOverlapRatio: 1,
      captionContent: (slide) => {
        let captionElement = slide.data.element
          .closest('li, div')
          .querySelector('.slide-caption');
        return captionElement ? captionElement.innerHTML : '';
      },
    });

    return lightbox;
  });
}

initPhotoswipe();
